import React, { Fragment, useEffect } from "react";
import { Pagina } from "../template/Template";
import { AuthContext } from "../../App";
import { ThemeProvider } from "@material-ui/core/styles";
import { format } from "date-fns";
import {
    listarByConContainer,
    listarByUsuId,
    listarByUsuIdPercentual,
} from "../../services/ContainerService";
import { Button } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import {
    DataGrid,
    GridToolbarContainer,
    GridFilterToolbarButton,
} from "@material-ui/data-grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { Formik } from "formik";
import { Loading } from "../Loading";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TextField from "@material-ui/core/TextField";

import ReactExport from "react-export-excel";

import {
    CirculoStatus,
    CirculoVeredito,
    CirculoDoisVeredito,
} from "../status/Circulos";
import { usuarioFindAll } from "../../services/UsuarioService";

import { useStyles } from '../styles/StyleConsultar';
import { theme } from "../styles/Theme";

export default function Consultar() {
    const classes = useStyles();
    const { state: authState } = React.useContext(AuthContext);

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`tabpanel-${index}`}
                aria-labelledby={`tab-${index}`}
                {...other}
            >
                {value === index && <div p={2}>{children}</div>}
            </div>
        );
    }

    let usuario;
    var container;
    var operacao = "Todos";

    const Content = () => {
        const [listContainers, setListContainers] = React.useState([]);
        const [listPercentuais, setListPercentuais] = React.useState([]);
        const [listUsuarios, setListUsuarios] = React.useState([]);
        const [openLoading, setOpenLoading] = React.useState(false);
        const [value, setValue] = React.useState(0);

        const ExcelFile = ReactExport.ExcelFile;
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

        useEffect(() => {
            usuarioFindAll().then((resp) => {
                setListUsuarios(resp.data);
            });
        }, []);

        const CustomToolbarOperador = () => {
            return (
                <GridToolbarContainer>
                    <GridFilterToolbarButton />
                </GridToolbarContainer>
            );
        };

        const CustomToolbarContainer = () => {
            return (
                <GridToolbarContainer>
                    <GridFilterToolbarButton />
                </GridToolbarContainer>
            );
        };

        /*
    +--------------------------------------------------------------------------------+ 
    |                               Tab Container                                     |
    +--------------------------------------------------------------------------------+
    */

        const TabContainer = () => {
            return (
                <Formik
                    initialValues={{
                        container: container,
                    }}
                    validate={(values) => {
                        const errors = {};
                        if (!values.container) {
                            errors.container = "Container é Obrigatório";
                        } else if (values.container.length < 3) {
                            errors.container = "Minimo de três caracteres são obrigatórios";
                        }
                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting }) => {
                        setOpenLoading(true);
                        container = values.container;
                        const list = await listarByConContainer(values.container);
                        setListContainers(list.data);
                        setOpenLoading(false);
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        isValid,
                    }) => (
                        <form onSubmit={handleSubmit} className={classes.form}>
                            <div className={classes.boxCenter}>
                                <Paper className={classes.box} elevation={7}>
                                    <Loading open={openLoading} />

                                    <div className={classes.dashboard_header}>
                                        <div className={classes.dashboard_header_status}>
                                            <div className={classes.center_data}>
                                                <div className={classes.entrada_de_dados}>
                                                    {/* <div className={classes.campos}>
                            <InputLabel id="label-container">
                              Container
                            </InputLabel>
                          </div> */}
                                                    <div className={classes.campos}>
                                                        <TextField
                                                            value={values.container}
                                                            name="container"
                                                            id="container"
                                                            type="text"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            label="Número do container"
                                                            className={classes.contanerName}
                                                            helperText={errors.container}
                                                        />
                                                    </div>
                                                    <div className={classes.campos}>
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            type="submit"
                                                            disabled={!isValid}
                                                        >
                                                            Filtrar
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={classes.boxPrancheta}>
                                        <div className={classes.boxDataGrid}>
                                            <ThemeProvider theme={theme}>
                                                <DataGrid
                                                    rows={listContainers}
                                                    disableColumnMenu
                                                    disableColumnReorder
                                                    pageSize={7}
                                                    id="id"
                                                    components={{
                                                        Toolbar: CustomToolbarContainer,
                                                    }}
                                                    columns={[
                                                        {
                                                            field: "tipo",
                                                            headerName: "Tipo",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 135,
                                                            sortable: false,
                                                        },
                                                        {
                                                            field: "con_container",
                                                            headerName: "Container",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 204,
                                                            sortable: false,
                                                        },
                                                        {
                                                            field: "con_data_scan",
                                                            headerName: "Data Scan",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 160,
                                                            sortable: false,
                                                            align: "center",
                                                            valueFormatter: (params) => {
                                                                if (!(params.value == null)) {
                                                                    return format(
                                                                        new Date(params.value),
                                                                        "dd/MM/yy-HH:mm"
                                                                    );
                                                                }
                                                                return undefined;
                                                            },
                                                        },
                                                        {
                                                            field: "trk_id",
                                                            headerName: "Truck ID",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 200,
                                                            sortable: false,
                                                        },
                                                        {
                                                            field: "sit_id",
                                                            headerName: "Site",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 170,
                                                            align: "center",
                                                        },
                                                        {
                                                            field: "ia_veredito",
                                                            headerName: "Ver.IA/Terminal",
                                                            headerClassName: "header_grid",
                                                            headerAlign: "center",
                                                            width: 160,
                                                            align: "center",
                                                            renderCell: (params) => (
                                                                <CirculoVeredito
                                                                    veredito={params.value}
                                                                    text={params.value}
                                                                />
                                                            ),
                                                        },
                                                        {
                                                            field: "v3_veredito",
                                                            headerName: "Vereditos",
                                                            headerClassName: "header_grid",
                                                            headerAlign: "center",
                                                            width: 160,
                                                            align: "center",
                                                            renderCell: (params) => (
                                                                <div>
                                                                    <CirculoDoisVeredito
                                                                        veredito1={params.value.split(",")[0]}
                                                                        veredito2={params.value.split(",")[1]}
                                                                    />
                                                                </div>
                                                            ),
                                                        },
                                                        {
                                                            field: "con_situacao",
                                                            headerName: "Status Processo",
                                                            headerClassName: "header_grid",
                                                            width: 160,
                                                            align: "center",
                                                            renderCell: (params) => (
                                                                <CirculoStatus text={params.value} />
                                                            ),
                                                        },
                                                    ]}
                                                />
                                            </ThemeProvider>
                                        </div>
                                    </div>
                                </Paper>
                            </div>
                        </form>
                    )}
                </Formik>
            );
        };

        /*
    +--------------------------------------------------------------------------------+ 
    |                               Tab Operador                                     |
    +--------------------------------------------------------------------------------+
    */

        const TabOperador = () => {
            return (
                <Formik
                    initialValues={{
                        usuario: usuario,
                        operacao: operacao,
                    }}
                    validate={(values) => {
                        const errors = {};
                        if (!values.usuario) {
                            errors.usuario = "Seleção do usuário é obrigatória";
                        }
                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting }) => {
                        setOpenLoading(true);
                        //                usuario = values.usuario;
                        //                operacao = values.operacao;
                        const list = await listarByUsuId(values.usuario, values.operacao);
                        setListContainers(list.data);
                        const listPercent = await listarByUsuIdPercentual(values.usuario);
                        setListPercentuais(listPercent.data);
                        setOpenLoading(false);
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        isValid,
                    }) => (
                        <form onSubmit={handleSubmit} className={classes.form}>
                            <div className={classes.boxCenter}>
                                <Paper className={classes.box} elevation={7}>
                                    <Loading open={openLoading} />

                                    <div className={classes.dashboard_header}>
                                        <div className={classes.dashboard_header_status}>
                                            <div>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        width: "100%",
                                                        alignContent: "center",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            width: "100%",
                                                            justifyContent: "space-between",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                marginLeft: "10px",
                                                                marginRight: "10px",
                                                            }}
                                                        >
                                                            <InputLabel id="label-usuarios">
                                                                Operadores
                                                            </InputLabel>

                                                            <div>
                                                                <Select
                                                                    labelId="label-usuarios"
                                                                    id="usuario"
                                                                    name="usuario"
                                                                    label="usuario"
                                                                    value={values.opeId}
                                                                    style={{ width: "250px" }}
                                                                    onChange={handleChange}
                                                                >
                                                                    {listUsuarios.map((option) => (
                                                                        <MenuItem
                                                                            key={option.usu_id}
                                                                            value={option.usu_id}
                                                                        >
                                                                            {option.usu_apelido}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <RadioGroup
                                                                aria-label="operacao"
                                                                value={values.operacao}
                                                                id="operacao"
                                                                name="operacao"
                                                                style={{ width: "450px" }}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                row
                                                            >
                                                                <FormControlLabel
                                                                    value="Todos"
                                                                    control={<Radio />}
                                                                    label="Todos"
                                                                />
                                                                <FormControlLabel
                                                                    value="Aprovado"
                                                                    control={<Radio />}
                                                                    label="Ok"
                                                                />
                                                                <FormControlLabel
                                                                    value="Inconsistente"
                                                                    control={<Radio />}
                                                                    label="Inconsistente"
                                                                />
                                                                <FormControlLabel
                                                                    value="Suspeito"
                                                                    control={<Radio />}
                                                                    label="Suspeito"
                                                                />
                                                            </RadioGroup>
                                                        </div>
                                                        <div>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                type="submit"
                                                                style={{
                                                                    marginRight: "15px",
                                                                    fontWeight: "bold",
                                                                }}
                                                                disabled={!isValid}
                                                            >
                                                                Filtrar
                                                            </Button>
                                                            <ExcelFile
                                                                element={
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        style={{
                                                                            marginLeft: "10px",
                                                                            fontWeight: "bold",
                                                                        }}
                                                                    >
                                                                        Baixar Planilha
                                                                    </Button>
                                                                }
                                                                filename="Containers"
                                                            >
                                                                <ExcelSheet
                                                                    data={listContainers}
                                                                    name="Containers"
                                                                >
                                                                    <ExcelColumn label="Tipo" value="tipo" />
                                                                    <ExcelColumn
                                                                        label="Container"
                                                                        value="con_container"
                                                                    />
                                                                    <ExcelColumn
                                                                        label="Track ID"
                                                                        value="trk_id"
                                                                    />
                                                                    <ExcelColumn label="Site" value="sit_id" />
                                                                    <ExcelColumn
                                                                        label="Situação"
                                                                        value="con_situacao"
                                                                    />
                                                                    <ExcelColumn
                                                                        label="Analise IA"
                                                                        value="con_ai_analise"
                                                                    />
                                                                    <ExcelColumn
                                                                        label="Veredito Porto"
                                                                        value="ver_id_porto"
                                                                    />
                                                                    <ExcelColumn
                                                                        label="Analise Operador"
                                                                        value="v1_veredito_analise"
                                                                    />
                                                                    <ExcelColumn
                                                                        label="Veredito Operador"
                                                                        value="v1_veredito_id"
                                                                    />
                                                                    <ExcelColumn
                                                                        label="Analise Supervisor"
                                                                        value="v2_veredito_analise"
                                                                    />
                                                                    <ExcelColumn
                                                                        label="Veredito Supervisor"
                                                                        value="v2_veredito_id"
                                                                    />
                                                                </ExcelSheet>
                                                            </ExcelFile>
                                                        </div>
                                                    </div>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            width: "100%",
                                                            justifyContent: "space-around",
                                                        }}
                                                    >
                                                        {listPercentuais.map((percents) => (
                                                            <div>
                                                                <span className={classes.span_name}>
                                                                    {percents.situacao}
                                                                </span>
                                                                <span className={classes.span_value}>
                                                                    {percents.percentual}%
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={classes.boxPrancheta}>
                                        <div className={classes.boxDataGrid}>
                                            <ThemeProvider theme={theme}>
                                                <DataGrid
                                                    rows={listContainers}
                                                    disableColumnMenu
                                                    disableColumnReorder
                                                    id="id"
                                                    components={{
                                                        Toolbar: CustomToolbarOperador,
                                                    }}
                                                    columns={[
                                                        {
                                                            field: "tipo",
                                                            headerName: "Tipo",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 125,
                                                            sortable: false,
                                                            align: "center",
                                                        },
                                                        {
                                                            field: "v1_usu_nome",
                                                            headerName: "Operador",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 200,
                                                            sortable: false,
                                                        },
                                                        {
                                                            field: "con_data_entrada",
                                                            headerName: "Data",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            sortable: false,
                                                            align: "center",
                                                            valueFormatter: (params) => {
                                                                if (!(params.value == null)) {
                                                                    return format(
                                                                        new Date(params.value),
                                                                        "dd/MM/yy-HH:mm"
                                                                    );
                                                                }
                                                                return undefined;
                                                            },
                                                        },
                                                        {
                                                            field: "con_container",
                                                            headerName: "Container",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            sortable: false,
                                                        },
                                                        {
                                                            field: "sit_id",
                                                            headerName: "Site",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            align: "center",
                                                        },
                                                        {
                                                            field: "con_situacao",
                                                            headerName: "Status Processo",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            align: "center",
                                                        },
                                                        {
                                                            field: "ia_veredito",
                                                            headerName: "Ver.IA/Terminal",
                                                            headerClassName: "header_grid",
                                                            headerAlign: "center",
                                                            width: 140,
                                                            align: "center",
                                                            renderCell: (params) => (
                                                                <CirculoVeredito veredito={params.value} />
                                                            ),
                                                        },
                                                        {
                                                            field: "v1_veredito",
                                                            headerName: "Ver.Operador",
                                                            headerClassName: "header_grid",
                                                            headerAlign: "center",
                                                            width: 140,
                                                            align: "center",
                                                            renderCell: (params) => (
                                                                <CirculoVeredito
                                                                    veredito={params.value}
                                                                    text={params.value}
                                                                />
                                                            ),
                                                        },
                                                        {
                                                            field: "v2_veredito",
                                                            headerName: "Ver.Supervisor",
                                                            headerAlign: "center",
                                                            headerClassName: "header_grid",
                                                            width: 140,
                                                            align: "center",
                                                            renderCell: (params) => (
                                                                <CirculoVeredito
                                                                    veredito={params.value}
                                                                    text={params.value}
                                                                />
                                                            ),
                                                        },
                                                    ]}
                                                />
                                            </ThemeProvider>
                                        </div>
                                    </div>
                                </Paper>
                            </div>
                        </form>
                    )}
                </Formik>
            );
        };

        function a11yProps(index) {
            return {
                id: `tab-${index}`,
                "aria-controls": `tabpanel-${index}`,
            };
        }

        const handleChange = (event, newValue) => {
            setListContainers([]);
            setListPercentuais([]);

            usuario = "";
            container = "";
            operacao = "Todos";

            setValue(newValue);
        };

        return (
            <div className={classes.boxCenter}>
                <Paper className={classes.box} elevation={7}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="simple tabs example"
                        style={{ background: "#191970", color: "white" }}
                    >
                        <Tab label="Operador" {...a11yProps(0)} />
                        <Tab label="Container" {...a11yProps(1)} />
                    </Tabs>
                    <TabPanel value={value} index={0}>
                        {TabOperador()}
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        {TabContainer()}
                    </TabPanel>
                </Paper>
            </div>
        );
    };

    return (
        <Fragment>
            <Pagina authState={authState} Content={Content} HeaderDesc="CONSULTAR" />
        </Fragment>
    );
}
